import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'components/App/App';
import 'animate.css/animate.css';
import './theme/index.css';
import {BrowserRouter as Router} from "react-router-dom";

import SmoothScroll from 'smoothscroll-for-websites';
import smoothscroll from 'smoothscroll-polyfill';

import {isIphone, isSafari} from './utils/index';

if (isIphone && isSafari) {
    document.documentElement.classList.add("no-animation");
}

// kick off the polyfill!
smoothscroll.polyfill();

SmoothScroll({
    animationTime : 600, // [ms]
    stepSize : 60, // [px]
});

window.addEventListener("beforeunload", function (event) {
    window.scrollTo(0, 0);
});

const component = (
    <Router>
        <App/>
    </Router>
);

ReactDOM.render(component, document.getElementById('root'));